export class MachineInspectionParamModel {
    constructor({ id, description, status, remark, attachments }) {
        this.id = id;
        this.description = description;
        this.status = status;
        this.remark = remark;
        this.attachments = attachments
    }

    static fromJson(json) {
        return new MachineInspectionParamModel({
            id: json.id,
            description: json?.parametro?.nome ?? json?.nome,
            status: json.status,
            remark: json.observacao,
            attachments: json.anexos
        });
    }
}
